import { MUTATION_TYPE, ACTION_TYPE, GETTER_TYPE } from './types'
import EducationAPI from '@/api/education'
import TestAPI from '@/api/test'
import SimulatorTeacherAPI from '@/api/training/teacher'

export default {
  state: {
    participants: [],
    studentsCourseProgress: [],
    studentsTestProgress: [],
    reportId: 0,
    testReviewMode: false,
    solvedByStudent: [],
    simulatorMarks: [],
    groupTrainingSettings: {},
    groupTrainingStudents: [],
    groupTrainingTeams: [],
    groupTrainingMode: '',
    pages: 0,
    currentPage: 1,
    paginationPageSize: 10,
    total: 0
  },

  mutations: {
    [MUTATION_TYPE.setParticipants]: (state, participants) => {
      state.participants = participants
    },
    [MUTATION_TYPE.setStudentsProgress]: (state, participants) => {
      state.studentsCourseProgress = participants
    },
    [MUTATION_TYPE.setTestProgress]: (state, reports) => {
      state.studentsTestProgress = reports
    },
    [MUTATION_TYPE.setReportId]: (state, id) => {
      state.reportId = id
    },
    [MUTATION_TYPE.setTestReviewMode]: (state, mode) => {
      state.testReviewMode = mode
    },
    [MUTATION_TYPE.setSolvedByStudent]: (state, solved) => {
      state.solvedByStudent = solved
    },
    [MUTATION_TYPE.setSimulatorMarks]: (state, marks) => {
      state.simulatorMarks = marks
    },
    [MUTATION_TYPE.setGroupTrainingSettings]: (state, settings) => {
      state.groupTrainingSettings = settings
    },
    [MUTATION_TYPE.setGroupTrainingStudents]: (state, students) => {
      state.groupTrainingStudents = students
    },
    [MUTATION_TYPE.setGroupTrainingTeams]: (state, teams) => {
      state.groupTrainingTeams = teams
    },
    [MUTATION_TYPE.addStudents]: (state, students) => {
      const studentsIds = state.groupTrainingStudents.map((s) => s.id)
      students.forEach((st) => {
        if (!studentsIds.includes(st[1].id)) {
          state.groupTrainingStudents.push(st[1])
        }
      })
    },
    [MUTATION_TYPE.removeStudents]: (state, students) => {
      const newIds = students.map((st) => Number(st[0]))
      state.groupTrainingStudents.forEach((d, i) => {
        if (!newIds.includes(d.id)) {
          if (d.group && d.role) {
            const team = state.groupTrainingTeams.filter((t) => t.id === d.group)[0]
            if (team) {
              const roles = team.roles.filter((r) => r.role === d.role)
              team.roles = team.roles.filter((t) => t.role !== d.role)
              if (roles.length > 1) {
                roles.splice(0, 1)
                roles.forEach((r) => {
                  team.roles.push(r)
                })
              }
            }

            state.groupTrainingTeams.map((t) => (t.id === d.group ? team : t))
          }
          state.groupTrainingStudents.splice(i, 1)
        }
      })
    },
    [MUTATION_TYPE.updateStudent]: (state, stud) => {
      const student = state.groupTrainingStudents.filter((st) => st.id === stud.id)[0]
      student.role = stud.role
      student.group = stud.group
      state.groupTrainingStudents.map((st) => (st.id === stud.id ? student : st))
    },
    [MUTATION_TYPE.setGroupTrainingMode]: (state, mode) => {
      state.groupTrainingMode = mode
    },
    [MUTATION_TYPE.updateTeams]: (state, { team, role, oldTeam }) => {
      if (state.groupTrainingTeams.length > 0) {
        if (!oldTeam) {
          const cteam = state.groupTrainingTeams.filter((t) => t.id === team)[0]
          if (cteam) {
            let rs = cteam.roles
            let reload = false
            rs = rs.map((r) => {
              if (r.id === role.id) {
                reload = true
                return role
              }
              return r
            })
            if (!reload) {
              rs.push(role)
            }
            cteam.roles = rs
            state.groupTrainingTeams.map((t) => (t.id === team ? cteam : t))
          } else {
            state.groupTrainingTeams
              .push({
                id: team,
                roles: [role]
              })
          }
        } else {
          const ot = state.groupTrainingTeams.filter((t) => t.id === oldTeam)[0]
          ot.roles = ot.roles.filter((r) => r.id !== role.id)
          state.groupTrainingTeams.map((t) => (t.id === oldTeam ? ot : t))

          const cteam = state.groupTrainingTeams.filter((t) => t.id === team)[0]
          if (cteam) {
            cteam.roles.push(role)
            state.groupTrainingTeams.map((t) => (t.id === team ? cteam : t))
          } else {
            state.groupTrainingTeams
              .push({
                id: team,
                roles: [role]
              })
          }
        }
      } else {
        state.groupTrainingTeams
          .push({
            id: team,
            roles: [role]
          })
      }
    },
    [MUTATION_TYPE.setCurrentPage]: (state, page) => {
      state.currentPage = page
    },
    [MUTATION_TYPE.setCurrentPageSize]: (state, pageSize) => {
      state.paginationPageSize = pageSize
    },
    [MUTATION_TYPE.setTotal]: (state, total) => {
      state.total = total
    },
    [MUTATION_TYPE.setPages]: (state, pages) => {
      state.pages = pages
    }
  },

  actions: {
    [ACTION_TYPE.fetchCourseStudentsProgress]:
      async ({ commit }, { courseId, classes, organizationId }) => {
        const response = await EducationAPI.getCourseStudentsProgress(
          courseId,
          classes,
          organizationId,
        )
        commit('setStudentsProgress', response.data)
        commit('setParticipants', response.data)
      },
    [ACTION_TYPE.fetchTestStudentsProgress]:
      async ({ commit }, { testId, classes, organizationId }) => {
        const response = await TestAPI.getTestProgress(
          testId,
          classes,
          organizationId,
        )
        commit('setTestProgress', response.data)
      },
    [ACTION_TYPE.fetchSimulatorMarks]: async ({ state, commit },
      { simulatorId, filters, sorting }) => {
      const response = await SimulatorTeacherAPI
        .getMarks(simulatorId, filters, sorting, state.currentPage,
          state.paginationPageSize)
      commit(MUTATION_TYPE.setPages, response.data.pages)
      commit(MUTATION_TYPE.setTotal, response.data.total)
      commit(MUTATION_TYPE.setSimulatorMarks, response.data.docs)
    }
  },

  getters: {
    [GETTER_TYPE.getParticipants]: (state) => state.participants,
    [GETTER_TYPE.getStudentsProgress]: (state) => state.studentsCourseProgress,
    [GETTER_TYPE.getTestProgress]: (state) => state.studentsTestProgress,
    [GETTER_TYPE.getReportId]: (state) => state.reportId,
    [GETTER_TYPE.getTestReviewMode]: (state) => state.testReviewMode,
    [GETTER_TYPE.getSolvedByStudent]: (state) => state.solvedByStudent,
    [GETTER_TYPE.getSimulatorMarks]: (state) => state.simulatorMarks,
    [GETTER_TYPE.getGroupTrainingSettings]: (state) => state.groupTrainingSettings,
    [GETTER_TYPE.getGroupTrainingStudents]: (state) => state.groupTrainingStudents,
    [GETTER_TYPE.getGroupTrainingMode]: (state) => state.groupTrainingMode,
    [GETTER_TYPE.getGroupTrainingTeams]: (state) => state.groupTrainingTeams,
    [GETTER_TYPE.getPages]: (state) => state.pages,
    [GETTER_TYPE.getCurrentPage]: (state) => state.currentPage,
    [GETTER_TYPE.getPaginationPageSize]: (state) => state.paginationPageSize,
    [GETTER_TYPE.getTotal]: (state) => state.total
  }
}
